// extracted by mini-css-extract-plugin
export default {"fabContainer":"fab_fabContainer__PlNad","link":"fab_link__DqZp3","pulse":"fab_pulse__7c4ml","icon":"fab_icon__-IL9D","long":"fab_long__BWI+l"};